import { render, staticRenderFns } from "./VoiceRecorder.vue?vue&type=template&id=190a7378"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js"
import style0 from "./VoiceRecorder.vue?vue&type=style&index=0&id=190a7378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports